import { CONVERTER_COMMON_LANG } from "./common";
import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_LANG: {
  LIST_LABEL_SEQ: MvnCodeFE;
  LIST_LABEL_PROTOCOL: MvnCodeFE;
  LIST_LABEL_ROLE: MvnCodeFE;
  LIST_LABEL_NAME: MvnCodeFE;
  LIST_LABEL_DESCRIPTION: MvnCodeFE;
  LIST_LABEL_SDTMIG_VER: MvnCodeFE;
  LIST_LABEL_SPONSOR: MvnCodeFE;
  LIST_LABEL_CREATOR: MvnCodeFE;
  LIST_LABEL_CREATED_TIME: MvnCodeFE;
  LIST_MENU_NEW_ADAM: MvnCodeFE;
  LIST_MENU_LOCK: MvnCodeFE;
  LIST_MENU_UNLOCK: MvnCodeFE;
  LIST_MENU_UPDATE: MvnCodeFE;
  LIST_MENU_DELETE: MvnCodeFE;
  LIST_MENU_COPY: MvnCodeFE;
  LIST_MENU_STUDY_INFORMATION: MvnCodeFE;
  LIST_ADD: MvnCodeFE;
  LIST_EMPTY_TITLE: MvnCodeFE;
  LIST_EMPTY_DESCRIPTION: MvnCodeFE;
  DIALOG_ADD_TITLE: MvnCodeFE;
  DIALOG_EDIT_TITLE: MvnCodeFE;
  DIALOG_DELETE_TITLE: MvnCodeFE;
  DIALOG_DELETE_DESCRIPTION: MvnCodeFE;
  DIALOG_FORM_REQUIRED: MvnCodeFE;
  DIALOG_FORM_MAXLENGTH: MvnCodeFE;
  DIALOG_CONFIRM: MvnCodeFE;
  DIALOG_CANCEL: MvnCodeFE;
  DIALOG_FORM_NAME: MvnCodeFE;
  DIALOG_PLACEHOLDER_NAME: MvnCodeFE;
  DIALOG_FORM_DESCRIPTION: MvnCodeFE;
  DIALOG_PLACEHOLDER_DESCRIPTION: MvnCodeFE;
  DIALOG_FORM_PROTOCOL: MvnCodeFE;
  DIALOG_PLACEHOLDER_PROTOCOL: MvnCodeFE;
  DIALOG_FORM_SDTMIG_VER: MvnCodeFE;
  DIALOG_PLACEHOLDER_SDTMIG_VER: MvnCodeFE;
  DIALOG_FORM_CT_VER: MvnCodeFE;
  DIALOG_PLACEHOLDER_CT_VER: MvnCodeFE;
  DIALOG_FORM_AFFILIATION: MvnCodeFE;
  DIALOG_PLACEHOLDER_AFFILIATION: MvnCodeFE;
  STUDY_ADD_SUCCEED: MvnCodeFE;
  STUDY_ADD_FAIL: MvnCodeFE;
  STUDY_EDIT_SUCCEED: MvnCodeFE;
  STUDY_EDIT_FAIL: MvnCodeFE;
  STUDY_DELETE_SUCCEED: MvnCodeFE;
  STUDY_DELETE_FAIL: MvnCodeFE;
  STUDY_LOCK_SUCCEED: MvnCodeFE;
  STUDY_LOCK_FAIL: MvnCodeFE;
  STUDY_UNLOCK_SUCCEED: MvnCodeFE;
  STUDY_UNLOCK_FAIL: MvnCodeFE;
  STUDY_COPY_SUCCEED: MvnCodeFE;
  STUDY_COPY_FAIL: MvnCodeFE;
  STUDY_COPYING_LOADING_MESSAGE: MvnCodeFE;
  DIALOG_ADAM_DELETE_TITLE: MvnCodeFE;
  DIALOG_ADAM_DELETE_DESCRIPTION: MvnCodeFE;
  DIALOG_STUDY_INFORMATION_TITLE: MvnCodeFE;
  DIALOG_ADAM_ADD_TITLE: MvnCodeFE;
  DIALOG_ADAM_ADD_DESCRIPTION: MvnCodeFE;
  DIALOG_ADAM_EDIT_TITLE: MvnCodeFE;
  DIALOG_ADAM_EDIT_DESCRIPTION: MvnCodeFE;
  DIALOG_ADAM_FORM_NAME: MvnCodeFE;
  DIALOG_ADAM_PLACEHOLDER_NAME: MvnCodeFE;
  DIALOG_ADAM_FORM_ADAMIG_VER: MvnCodeFE;
  DIALOG_ADAM_PLACEHOLDER_ADAMIG_VER: MvnCodeFE;
  DIALOG_ADAM_FORM_ADAM_CT_VER: MvnCodeFE;
  DIALOG_ADAM_PLACEHOLDER_ADAM_CT_VER: MvnCodeFE;
  DIALOG_ADAM_FORM_STUDY_INFO: MvnCodeFE;
  DIALOG_ADAM_INFO_SDTM_STUDY_NAME: MvnCodeFE;
  DIALOG_ADAM_INFO_SDTM_DESCRIPTION: MvnCodeFE;
  DIALOG_ADAM_INFO_PROTOCOL_NAME: MvnCodeFE;
  DIALOG_ADAM_INFO_SDTMIG_VER: MvnCodeFE;
  DIALOG_ADAM_INFO_SDTM_CT_VER: MvnCodeFE;
  DIALOG_ADAM_INFO_SPONSOR: MvnCodeFE;
  ADAM_STUDY_ADD_SUCCEED: MvnCodeFE;
  ADAM_STUDY_ADD_FAIL: MvnCodeFE;
  ADAM_STUDY_EDIT_SUCCEED: MvnCodeFE;
  ADAM_STUDY_EDIT_FAIL: MvnCodeFE;
  ADAM_STUDY_LOCK_SUCCEED: MvnCodeFE;
  ADAM_STUDY_LOCK_FAIL: MvnCodeFE;
  ADAM_STUDY_UNLOCK_SUCCEED: MvnCodeFE;
  ADAM_STUDY_UNLOCK_FAIL: MvnCodeFE;
  ADAM_STUDY_DELETE_SUCCEED: MvnCodeFE;
  ADAM_STUDY_DELETE_FAIL: MvnCodeFE;
  ADAM_STUDY_MAX_LIMIT_FAIL: MvnCodeFE;
} = {
  LIST_LABEL_SEQ: {
    ko: "No.",
    en: "No.",
  },
  LIST_LABEL_PROTOCOL: {
    ko: "프로토콜명",
    en: "Protocol Name",
  },
  LIST_LABEL_ROLE: {
    ko: "역할",
    en: "Role",
  },
  LIST_LABEL_NAME: {
    ko: "스터디 이름",
    en: "Study Name",
  },
  LIST_LABEL_DESCRIPTION: {
    ko: "스터디 제목",
    en: "Study Description",
  },
  LIST_LABEL_SDTMIG_VER: {
    ko: "SDTMIG Ver.",
    en: "SDTMIG Ver.",
  },
  LIST_LABEL_SPONSOR: {
    ko: "스폰서",
    en: "Sponsor",
  },
  LIST_LABEL_CREATOR: {
    ko: "생성자",
    en: "Creator",
  },
  LIST_LABEL_CREATED_TIME: {
    ko: "생성일시",
    en: "Creation Timestamp",
  },
  LIST_MENU_NEW_ADAM: {
    ko: "ADaM 생성",
    en: "Create ADAM",
  },
  LIST_MENU_LOCK: {
    ko: "잠금",
    en: "Lock",
  },
  LIST_MENU_UNLOCK: {
    ko: "잠금 해제",
    en: "UnLock",
  },
  LIST_MENU_STUDY_INFORMATION: {
    ko: "스터디 정보",
    en: "Study Info",
  },
  LIST_MENU_UPDATE: CONVERTER_COMMON_LANG.EDIT_VERB,
  LIST_MENU_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  LIST_MENU_COPY: CONVERTER_COMMON_LANG.COPY_VERB,
  LIST_ADD: CONVERTER_COMMON_LANG.ADD_VERB,
  LIST_EMPTY_TITLE: {
    ko: "등록된 데이터가 없습니다.",
    en: "No data is available.",
  },
  LIST_EMPTY_DESCRIPTION: {
    ko: "스터디를 생성하고 원하는 스터디로 진입할 수 있습니다.",
    en: "You can create a study and join the one you want.",
  },
  DIALOG_ADD_TITLE: {
    ko: "스터디 생성",
    en: "Create Study",
  },
  DIALOG_EDIT_TITLE: {
    ko: "스터디 수정",
    en: "Modify the Study",
  },
  DIALOG_DELETE_TITLE: {
    ko: "삭제",
    en: "Deletion",
  },
  DIALOG_DELETE_DESCRIPTION: {
    ko: "스터디를 삭제하시겠습니까?",
    en: "Confirm deletion of the study.\nAre you sure you want to delete the study?",
  },
  DIALOG_CONFIRM: CONVERTER_COMMON_LANG.CONFIRM_VERB,
  DIALOG_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,
  DIALOG_FORM_NAME: {
    ko: "Study Name",
    en: "Study Name",
  },
  DIALOG_PLACEHOLDER_NAME: {
    ko: "스폰서가 스터디에 부여한 짧은 이름",
    en: "A short name assigned to the study by the sponsor.",
  },
  DIALOG_FORM_DESCRIPTION: {
    ko: "Study Description",
    en: "Study Description",
  },
  DIALOG_PLACEHOLDER_DESCRIPTION: {
    ko: "연구 제목",
    en: "Study Description",
  },
  DIALOG_FORM_PROTOCOL: {
    ko: "Protocol Name",
    en: "Protocol Name",
  },
  DIALOG_PLACEHOLDER_PROTOCOL: {
    ko: "프로토콜 이름 또는 번호",
    en: "Protocol Name or Number",
  },
  DIALOG_FORM_SDTMIG_VER: {
    ko: "SDTMIG Version 선택",
    en: "Select SDTMIG Version",
  },
  DIALOG_PLACEHOLDER_SDTMIG_VER: {
    ko: "SDTMIG Version",
    en: "SDTMIG Version",
  },
  DIALOG_FORM_CT_VER: {
    ko: "SDTM CT Version",
    en: "SDTM CT Version",
  },
  DIALOG_PLACEHOLDER_CT_VER: {
    ko: "SDTM CT Version",
    en: "SDTM CT Version",
  },
  DIALOG_FORM_AFFILIATION: {
    ko: "Sponsor",
    en: "Sponsor",
  },
  DIALOG_FORM_REQUIRED: CONVERTER_COMMON_LANG.FORM_REQUIRED,
  DIALOG_FORM_MAXLENGTH: {
    ko: "입력 제한 글자 수 {maxLength}자를 초과했습니다.",
    en: "The input exceeds the character limit of {maxLength}.",
  },
  DIALOG_PLACEHOLDER_AFFILIATION: {
    ko: "소속",
    en: "Affiliation",
  },
  STUDY_ADD_SUCCEED: {
    ko: "스터디를 생성했습니다.",
    en: "The study has been created.",
  },
  STUDY_ADD_FAIL: {
    ko: "스터디 생성에 실패했습니다.",
    en: "Failed to create the study.",
  },
  STUDY_EDIT_SUCCEED: {
    ko: "스터디를 수정했습니다.",
    en: "Study has been modified.",
  },
  STUDY_EDIT_FAIL: {
    ko: "스터디 수정에 실패했습니다.",
    en: "Failed to modify the study.",
  },
  STUDY_DELETE_SUCCEED: {
    ko: "스터디를 삭제했습니다.",
    en: "Study has been deleted.",
  },
  STUDY_DELETE_FAIL: {
    ko: "스터디 삭제에 실패했습니다.",
    en: "Failed to delete the study.",
  },
  STUDY_LOCK_SUCCEED: {
    ko: "스터디 잠금을 완료했습니다.",
    en: "The study has been locked.",
  },
  STUDY_LOCK_FAIL: {
    ko: "스터디 잠금에 실패했습니다.",
    en: "Failed to lock the study.",
  },
  STUDY_UNLOCK_SUCCEED: {
    ko: "스터디 잠금 해제를 완료했습니다.",
    en: "The study has been unlocked.",
  },
  STUDY_UNLOCK_FAIL: {
    ko: "스터디 잠금 해제에 실패했습니다.",
    en: "Failed to unlock the study.",
  },
  STUDY_COPY_SUCCEED: {
    ko: "스터디 복사가 완료되었습니다.",
    en: "The study has been successfully copied.",
  },
  STUDY_COPY_FAIL: {
    ko: "스터디 복사에 실패했습니다.",
    en: "Failed to copy the project.",
  },
  STUDY_COPYING_LOADING_MESSAGE: {
    ko: "스터디 복사 중입니다.\n잠시만 기다려 주세요.",
    en: "Copying study...\nThis may take a moment.",
  },
  DIALOG_ADAM_DELETE_TITLE: {
    ko: "ADaM 스터디 삭제",
    en: "Delete ADaM Study",
  },
  DIALOG_ADAM_DELETE_DESCRIPTION: {
    ko: "정말 이 ADaM 스터디를 삭제하시겠습니까?\n\n삭제 시 모든 분석 데이터셋과 관련 정보가 영구적으로 제거되며 복구할 수 없습니다. ",
    en: "Are you sure you want to delete this ADaM study?\n\nAll analysis datasets and related information will be permanently removed and cannot be recovered.",
  },
  DIALOG_STUDY_INFORMATION_TITLE: {
    ko: "스터디 정보",
    en: "Study Information",
  },
  DIALOG_ADAM_ADD_TITLE: {
    ko: "ADaM Study 생성",
    en: "Create ADaM Study",
  },
  DIALOG_ADAM_ADD_DESCRIPTION: {
    ko: "새로운 ADaM Study를 생성합니다.",
    en: "Create a new ADaM Study.",
  },
  DIALOG_ADAM_FORM_NAME: {
    ko: "ADaM Study Name",
    en: "ADaM Study Name",
  },
  DIALOG_ADAM_PLACEHOLDER_NAME: {
    ko: "스폰서가 스터디에 부여한 짧은 이름",
    en: "A short name assigned to the study by the sponsor.",
  },
  DIALOG_ADAM_FORM_ADAMIG_VER: {
    ko: "ADaMIG Version 선택",
    en: "Select ADaMIG Version",
  },
  DIALOG_ADAM_PLACEHOLDER_ADAMIG_VER: {
    ko: "ADaMIG Version",
    en: "ADaMIG Version",
  },
  DIALOG_ADAM_FORM_ADAM_CT_VER: {
    ko: "ADaM CT Version",
    en: "ADaM CT Version",
  },
  DIALOG_ADAM_PLACEHOLDER_ADAM_CT_VER: {
    ko: "ADaM CT Version",
    en: "ADaM CT Version",
  },
  DIALOG_ADAM_EDIT_TITLE: {
    ko: "ADaM Study 수정",
    en: "Edit ADaM Study",
  },
  DIALOG_ADAM_EDIT_DESCRIPTION: {
    ko: "새로운 ADaM Study를 생성합니다.",
    en: "Create a new ADaM Study.",
  },
  DIALOG_ADAM_FORM_STUDY_INFO: {
    ko: "SDTM 스터디 정보",
    en: "SDTM Study Information",
  },
  DIALOG_ADAM_INFO_SDTM_STUDY_NAME: {
    ko: "SDTM Study Name",
    en: "SDTM Study Name",
  },
  DIALOG_ADAM_INFO_SDTM_DESCRIPTION: {
    ko: "SDTM Description",
    en: "SDTM Description",
  },
  DIALOG_ADAM_INFO_PROTOCOL_NAME: {
    ko: "Protocol Name",
    en: "Protocol Name",
  },
  DIALOG_ADAM_INFO_SDTMIG_VER: {
    ko: "SDTM IG Version",
    en: "SDTM IG Version",
  },
  DIALOG_ADAM_INFO_SDTM_CT_VER: {
    ko: "SDTM CT Version",
    en: "SDTM CT Version",
  },
  DIALOG_ADAM_INFO_SPONSOR: {
    ko: "Sponsor",
    en: "Sponsor",
  },
  ADAM_STUDY_ADD_SUCCEED: {
    ko: "ADaM 스터디가 생성되었습니다.",
    en: "The ADaM study has been created.",
  },
  ADAM_STUDY_ADD_FAIL: {
    ko: "ADaM 스터디 생성에 실패했습니다.",
    en: "Failed to create the ADaM study.",
  },
  ADAM_STUDY_EDIT_SUCCEED: {
    ko: "ADaM 스터디가 수정되었습니다.",
    en: "ADaM Study has been updated.",
  },
  ADAM_STUDY_EDIT_FAIL: {
    ko: "ADaM 스터디 수정에 실패했습니다.",
    en: "Failed to update ADaM Study.",
  },
  ADAM_STUDY_LOCK_SUCCEED: {
    ko: "ADaM 스터디 잠금을 완료했습니다.",
    en: "The ADaM study has been locked.",
  },
  ADAM_STUDY_LOCK_FAIL: {
    ko: "ADaM 스터디 잠금에 실패했습니다.",
    en: "Failed to lock the ADaM study.",
  },
  ADAM_STUDY_UNLOCK_SUCCEED: {
    ko: "ADaM 스터디 잠금 해제를 완료했습니다.",
    en: "The ADaM study has been unlocked.",
  },
  ADAM_STUDY_UNLOCK_FAIL: {
    ko: "ADaM 스터디 잠금 해제에 실패했습니다.",
    en: "Failed to unlock the ADaM study.",
  },
  ADAM_STUDY_DELETE_SUCCEED: {
    ko: "ADaM 스터디가 삭제되었습니다.",
    en: "The ADaM study has been deleted.",
  },
  ADAM_STUDY_DELETE_FAIL: {
    ko: "ADaM 스터디 삭제에 실패했습니다.",
    en: "Failed to delete the ADaM study.",
  },
  ADAM_STUDY_MAX_LIMIT_FAIL: {
    ko: "ADaM Study는 최대 2개까지 생성 가능합니다.",
    en: "A maximum of 2 ADaM Studies can be created.",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_LANG);
